// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inbox-threadSubjectUnread-oEIG_ {
	font-size: 16px;
	font-weight: 500;
	color: var(--common-link-color);
	position: relative;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	overflow: hidden;
	padding-left: 10px;
}

.Inbox-threadSubjectUnread-oEIG_:hover,
.Inbox-threadSubjectUnread-oEIG_:focus {
	color: var(--common-link-color);
	text-decoration-color: var(--common-link-color);
}

.Inbox-threadSubjectUnread-oEIG_::before {
	content: '\\2022';
	position: absolute;
	top: -3px;
	left: 0px;
	font-size: 22px;
	line-height: 0.9;
	color: var(--alert-color);
}

@media screen and (max-width: 768px) {
	.Inbox-threadSubject-qWzgX {
		position: absolute;
		top: 36px;
		left: 61.5px;
		width: calc(100% - 105px);
		padding-left: 24px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.Inbox-threadSubject-qWzgX::before {
		left: 0;
	}

	.Inbox-inboxPaddingRight-ZCp1q {
		padding-right: 0;
		padding-bottom: 15px;
	}
}

.Inbox-textTruncate-Ir14_ {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.Inbox-threadName-Ebl8m {
	font-size: 14px;
	padding-top: 5px
}

.Inbox-threadName-Ebl8m div {
	text-overflow: ellipsis;
	overflow: hidden;
}

.Inbox-threadBody-Uz9qm {
	padding-top: 5px;
}

.Inbox-textMuted-XuZSE {
	color: var(--modalText-color);
	cursor: pointer;
	font-size: 14px;
}

.Inbox-threadLabel-U3lam {
	padding-top: 5px;
}

.Inbox-listUnstyled-QWuIF {
	padding-left: 0;
	list-style: none;
	line-height: 0.8;
}

.Inbox-space1-PM5y6 {
	margin-bottom: 6px;
}

.Inbox-spaceTop1-BsN8H {
	margin-top: 6px;
}

.Inbox-spaceTop2-cJh0f {
	margin-top: 12px;
}

.Inbox-threadAction-AbrU_ {
	display: inline-block;
}

.Inbox-iconText-iZdU1 {
	font-size: 14px;
	display: none;
}

.Inbox-PanelBody-QtWfj:hover .Inbox-iconText-iZdU1 {
	display: block;
}

.Inbox-showLg-qf7a1 {
	display: none !important;
}

.Inbox-labelText-_FG6d {
	font-size: 16px;
}

.Inbox-tabs-bhoU9 {
	margin-bottom: 0;
	padding: 0;
	list-style: none;
	display: table;
	table-layout: fixed;
	width: 100%;
	font-size: inherit;
}

.Inbox-threadRead-pXS_U {
	font-size: 16px;
	font-weight: 500;
	color: var(--common-text-color);
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	overflow: hidden;
}

.Inbox-threadRead-pXS_U:hover,
.Inbox-threadRead-pXS_U:focus {
	color: var(--common-text-color);
	text-decoration-color: var(--common-text-color);
}

.Inbox-noTextLine-rm8jZ {
	text-decoration: none !important;
}

@media screen and (min-width: 1128px) {
	.Inbox-showLg-qf7a1 {
		display: block !important;
	}
}

@media screen and (max-width: 768px) {
	.Inbox-progressContainerResponsive-HbOxz {
		padding: 0;
		margin: 0;
		overflow: hidden;
	}

	.Inbox-tabs-bhoU9 {
		width: 100%;
		margin-bottom: 15px;
		border-width: 1px;
		border-bottom: 1px solid var(--primary-border);
	}

	.Inbox-h4-Iwmm6 {
		font-size: 17px;
	}

	.Inbox-formControlSelect-xg0iP {
		font-size: 15px;
		width: 100%
	}

	.Inbox-threadAuthor-hkbch {
		position: static;
	}

	.Inbox-threadAvatar-e2NWg {
		float: left;
		padding-right: 0;
	}

	.Inbox-threadName-Ebl8m {
		font-size: 16px;
		margin-top: -5px;
		padding-top: 0;
		padding-left: 32px;
		position: static;
	}

	.Inbox-threadDate-SEzGS {
		font-weight: normal;
		font-size: 12px;
		position: absolute;
		top: 12px;
		right: 0px;
		color: var(--modalText-color);
	}

	.Inbox-threadLink-Od4te {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	.Inbox-threadBody-Uz9qm {
		position: static;
	}

	.Inbox-PanelBody-QtWfj:hover .Inbox-iconText-iZdU1 {
		display: none;
	}

	.Inbox-threadLabel-U3lam {
		position: absolute;
		top: 51px;
		left: 70px;
		padding-top: 10px;
	}
}

.Inbox-panelHeader-LqU4T {
	border-radius: 0;
	-webkit-box-shadow: unset;
	        box-shadow: unset;
	border: unset;
}

.Inbox-PanelBody-QtWfj {
	margin: 0;
	padding: 24px 0px;
	position: relative;
	border-bottom: 1px solid var(--primary-border);
}

.Inbox-formControlSelect-xg0iP {
	height: 40px;
	border-radius: 2px;
	margin-bottom: 8px;
	font-size: 16px;
	padding: 8px 10px;
	width: 100%;
	border: 1px solid var(--primary-border);
	background-color: var(--primary-white-bg);
	color: var(--common-text-color);
	display: inline-block;
	overflow: hidden;
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
}

.Inbox-textRight-IjCb_ {
	float: right;
}

.Inbox-listLayout-RD8rt {
	margin-bottom: 0;
	padding-left: 0;
	list-style: none;
	color: var(--common-text-color);
}

.Inbox-listLayout-RD8rt .Inbox-PanelBody-QtWfj:last-child {
	border-bottom: unset;
	padding-top: 24px;
	padding-bottom: 0;
}

.Inbox-listLayout-RD8rt .Inbox-PanelBody-QtWfj:first-child {
	padding-top: 0;
}

/*************************verification Styles end******************************************/

.Inbox-profileAvatarSection-oZf8O {
	position: relative;
	margin: 0 auto;
}

.Inbox-profileAvatarLink-IMDqZ {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	background-color: var(--common-gray-bg-color);
	border-radius: 50%;
	border: 2px solid var(--primary-white-bg);
	z-index: 5;
}

.Inbox-iconColor-aCcZu {
	color: var(--common-link-color);
}

@media screen and (max-width: 640px) {
	.Inbox-xsHidden-X8APs {
		display: none;
	}

	.Inbox-containerResponsive-zXS9R {
		margin-left: -15px;
		margin-right: -15px;
		width: auto;
	}
}

.Inbox-h4-Iwmm6 {
	font-size: 18px;
	font-weight: bold;
	line-height: 1.1;
}

.Inbox-active-fLLqM .Inbox-tabItem-AxTbR {
	color: var(--common-text-color);
	border-color: var(--common-link-color);
	text-decoration: none;
	font-weight: 500;
}

.Inbox-count-sAhbv {
	position: absolute;
	top: -10px;
	right: -18px;
	display: inline-block;
	text-align: center;
	white-space: nowrap;
	padding: 2.90px 2px;
	min-width: 19px;
	height: 19px;
	font-weight: 600;
	font-size: 10px;
	color: var(--white-text);
	border-radius: 50%;
	border: 1px solid var(--badge-primary-color);
	background: var(--badge-primary-color);
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	-ms-border-radius: 50%;
	-o-border-radius: 50%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	line-height: normal;
}

.Inbox-displayTable-xBQWO {
	width: 100%;
	display: table;
}

.Inbox-displayTableRow-KGrZY {
	width: 100%;
	display: table-row;
}

.Inbox-displayTableCell-XQSB4 {
	display: table-cell;
	vertical-align: middle;
}

.Inbox-contentSection-jBhew {
	position: relative;
	width: 90%;
	vertical-align: middle;
	background: var(--primary-white-bg);
	padding: 0px 24px;
}

.Inbox-displayTableCellIcon-AGofn {
	display: table-cell;
	width: 10%;
}

.Inbox-nameWidth-TQEOv {
	width: 20%;
}

.Inbox-addressWidth-kgU3E {
	width: 65%;
}

.Inbox-btnWidth-zqDaz {
	width: 15%;
}

.Inbox-vtrImg-sENev {
	vertical-align: middle;
}

.Inbox-inboxHeadingText-YcpDM {
	position: relative;
	display: inline-block;
}

.Inbox-inboxProfileAvatarLink-IV23S {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	width: 88px;
	height: 88px;
	overflow: hidden;
	border-radius: 50%;
	border: 2px solid var(--common-link-color);
	background-color: transparent;
	padding: 5px;
	position: relative;
	z-index: 5;
}

.Inbox-inboxProfileAvatarLink-IV23S img {
	width: 100%;
	height: 100%;
	-o-object-fit: contain;
	   object-fit: contain;
	background-color: var(--primary-white-bg);
	border-radius: 50%;
}

.Inbox-inBoxContentSection-qMA2u {
	padding-left: 29px;
	-webkit-box-flex: 1;
	    -ms-flex: 1 1;
	        flex: 1 1;
}

.Inbox-contentGridBox-Z8nRJ {
	display: grid;
	grid-template-columns: 28% 1fr auto;
}

.Inbox-displayFlex-a_VAN {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Inbox-iconSpace-_OCle {
	margin-right: 4px;
	position: relative;
	top: 2px;
}

.Inbox-inlineBlock-cZdYc {
	display: inline-block;
}

.Inbox-inboxPaddingRight-ZCp1q {
	padding-right: 24px;
}

.Inbox-displayFlexContainer-UpnG7 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

@media (max-width: 991px) and (min-width: 768px) {
	.Inbox-contentSection-jBhew {
		padding: 0px 12px;
	}
}

@media screen and (max-width: 767px) {
	.Inbox-displayBlock-SReoZ {
		display: block;
		width: 100% !important;
		margin-bottom: 6px;
	}

	.Inbox-contentSection-jBhew {
		width: 64% !important;
	}

	.Inbox-vtrImg-sENev {
		vertical-align: top;
	}

	.Inbox-contentSection-jBhew {
		padding: 0px 24px;
	}

	.Inbox-inboxProfileAvatarLink-IV23S {
		width: 70px;
		height: 70px;
	}

	.Inbox-count-sAhbv {
		top: -8px;
	}
}

@media screen and (max-width: 991px) {
	.Inbox-nameWidth-TQEOv {
		width: 30%;
	}

	.Inbox-addressWidth-kgU3E {
		width: 52%;
	}

	.Inbox-btnWidth-zqDaz {
		width: 18%;
	}

	.Inbox-contentSection-jBhew {
		width: 88%;
	}

	.Inbox-displayTableCellIcon-AGofn {
		display: table-cell;
		width: 12%;
	}
}

.Inbox-paddingR20-wbIvQ {
	padding-right: 20px;
}

@media (max-width: 640px) {
	.Inbox-contentGridBox-Z8nRJ {
		grid-template-columns: 100%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Inbox/Inbox.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;CAC/B,kBAAkB;CAClB,oBAAoB;CACpB,qBAAqB;CACrB,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;CAEC,+BAA+B;CAC/B,+CAA+C;AAChD;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC;EACC,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;CACxB;;CAEA;EACC,OAAO;CACR;;CAEA;EACC,gBAAgB;EAChB,oBAAoB;CACrB;AACD;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,gBAAgB;CAChB,cAAc;CACd,mBAAmB;CACnB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;CAC/B,oBAAoB;CACpB,qBAAqB;CACrB,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;;CAEC,+BAA+B;CAC/B,+CAA+C;AAChD;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC,UAAU;EACV,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;CAC/C;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf;CACD;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,6BAA6B;CAC9B;;CAEA;EACC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;CACX;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;CAClB;AACD;;AAEA;CACC,gBAAgB;CAChB,yBAAiB;SAAjB,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,8CAA8C;AAC/C;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,uCAAuC;CACvC,yCAAyC;CACzC,+BAA+B;CAC/B,qBAAqB;CACrB,gBAAgB;CAChB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,+BAA+B;AAChC;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA,2FAA2F;;AAE3F;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,6CAA6C;CAC7C,kBAAkB;CAClB,yCAAyC;CACzC,UAAU;AACX;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;CACZ;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,sCAAsC;CACtC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,wBAAwB;CACxB,kBAAkB;CAClB,4CAA4C;CAC5C,sCAAsC;CACtC,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,wBAAwB;CACxB,qBAAqB;CACrB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,sBAAsB;CACtB,mCAAmC;CACnC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;CAC1C,6BAA6B;CAC7B,YAAY;CACZ,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,yCAAyC;CACzC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAO;KAAP,aAAO;SAAP,SAAO;AACR;;AAEA;CACC,aAAa;CACb,mCAAmC;AACpC;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;CACnB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,SAAS;CACV;AACD;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,mBAAmB;EACnB,UAAU;CACX;AACD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,2BAA2B;CAC5B;AACD","sourcesContent":[".threadSubjectUnread {\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: var(--common-link-color);\n\tposition: relative;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tpadding-left: 10px;\n}\n\n.threadSubjectUnread:hover,\n.threadSubjectUnread:focus {\n\tcolor: var(--common-link-color);\n\ttext-decoration-color: var(--common-link-color);\n}\n\n.threadSubjectUnread::before {\n\tcontent: '\\2022';\n\tposition: absolute;\n\ttop: -3px;\n\tleft: 0px;\n\tfont-size: 22px;\n\tline-height: 0.9;\n\tcolor: var(--alert-color);\n}\n\n@media screen and (max-width: 768px) {\n\t.threadSubject {\n\t\tposition: absolute;\n\t\ttop: 36px;\n\t\tleft: 61.5px;\n\t\twidth: calc(100% - 105px);\n\t\tpadding-left: 24px;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t.threadSubject::before {\n\t\tleft: 0;\n\t}\n\n\t.inboxPaddingRight {\n\t\tpadding-right: 0;\n\t\tpadding-bottom: 15px;\n\t}\n}\n\n.textTruncate {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.threadName {\n\tfont-size: 14px;\n\tpadding-top: 5px\n}\n\n.threadName div {\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n}\n\n.threadBody {\n\tpadding-top: 5px;\n}\n\n.textMuted {\n\tcolor: var(--modalText-color);\n\tcursor: pointer;\n\tfont-size: 14px;\n}\n\n.threadLabel {\n\tpadding-top: 5px;\n}\n\n.listUnstyled {\n\tpadding-left: 0;\n\tlist-style: none;\n\tline-height: 0.8;\n}\n\n.space1 {\n\tmargin-bottom: 6px;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px;\n}\n\n.threadAction {\n\tdisplay: inline-block;\n}\n\n.iconText {\n\tfont-size: 14px;\n\tdisplay: none;\n}\n\n.PanelBody:hover .iconText {\n\tdisplay: block;\n}\n\n.showLg {\n\tdisplay: none !important;\n}\n\n.labelText {\n\tfont-size: 16px;\n}\n\n.tabs {\n\tmargin-bottom: 0;\n\tpadding: 0;\n\tlist-style: none;\n\tdisplay: table;\n\ttable-layout: fixed;\n\twidth: 100%;\n\tfont-size: inherit;\n}\n\n.threadRead {\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: var(--common-text-color);\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 2;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n}\n\n.threadRead:hover,\n.threadRead:focus {\n\tcolor: var(--common-text-color);\n\ttext-decoration-color: var(--common-text-color);\n}\n\n.noTextLine {\n\ttext-decoration: none !important;\n}\n\n@media screen and (min-width: 1128px) {\n\t.showLg {\n\t\tdisplay: block !important;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.progressContainerResponsive {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\toverflow: hidden;\n\t}\n\n\t.tabs {\n\t\twidth: 100%;\n\t\tmargin-bottom: 15px;\n\t\tborder-width: 1px;\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t}\n\n\t.h4 {\n\t\tfont-size: 17px;\n\t}\n\n\t.formControlSelect {\n\t\tfont-size: 15px;\n\t\twidth: 100%\n\t}\n\n\t.threadAuthor {\n\t\tposition: static;\n\t}\n\n\t.threadAvatar {\n\t\tfloat: left;\n\t\tpadding-right: 0;\n\t}\n\n\t.threadName {\n\t\tfont-size: 16px;\n\t\tmargin-top: -5px;\n\t\tpadding-top: 0;\n\t\tpadding-left: 32px;\n\t\tposition: static;\n\t}\n\n\t.threadDate {\n\t\tfont-weight: normal;\n\t\tfont-size: 12px;\n\t\tposition: absolute;\n\t\ttop: 12px;\n\t\tright: 0px;\n\t\tcolor: var(--modalText-color);\n\t}\n\n\t.threadLink {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tz-index: 1;\n\t}\n\n\t.threadBody {\n\t\tposition: static;\n\t}\n\n\t.PanelBody:hover .iconText {\n\t\tdisplay: none;\n\t}\n\n\t.threadLabel {\n\t\tposition: absolute;\n\t\ttop: 51px;\n\t\tleft: 70px;\n\t\tpadding-top: 10px;\n\t}\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\tbox-shadow: unset;\n\tborder: unset;\n}\n\n.PanelBody {\n\tmargin: 0;\n\tpadding: 24px 0px;\n\tposition: relative;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.formControlSelect {\n\theight: 40px;\n\tborder-radius: 2px;\n\tmargin-bottom: 8px;\n\tfont-size: 16px;\n\tpadding: 8px 10px;\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: var(--primary-white-bg);\n\tcolor: var(--common-text-color);\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tappearance: none;\n}\n\n.textRight {\n\tfloat: right;\n}\n\n.listLayout {\n\tmargin-bottom: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n\tcolor: var(--common-text-color);\n}\n\n.listLayout .PanelBody:last-child {\n\tborder-bottom: unset;\n\tpadding-top: 24px;\n\tpadding-bottom: 0;\n}\n\n.listLayout .PanelBody:first-child {\n\tpadding-top: 0;\n}\n\n/*************************verification Styles end******************************************/\n\n.profileAvatarSection {\n\tposition: relative;\n\tmargin: 0 auto;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tbackground-color: var(--common-gray-bg-color);\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary-white-bg);\n\tz-index: 5;\n}\n\n.iconColor {\n\tcolor: var(--common-link-color);\n}\n\n@media screen and (max-width: 640px) {\n\t.xsHidden {\n\t\tdisplay: none;\n\t}\n\n\t.containerResponsive {\n\t\tmargin-left: -15px;\n\t\tmargin-right: -15px;\n\t\twidth: auto;\n\t}\n}\n\n.h4 {\n\tfont-size: 18px;\n\tfont-weight: bold;\n\tline-height: 1.1;\n}\n\n.active .tabItem {\n\tcolor: var(--common-text-color);\n\tborder-color: var(--common-link-color);\n\ttext-decoration: none;\n\tfont-weight: 500;\n}\n\n.count {\n\tposition: absolute;\n\ttop: -10px;\n\tright: -18px;\n\tdisplay: inline-block;\n\ttext-align: center;\n\twhite-space: nowrap;\n\tpadding: 2.90px 2px;\n\tmin-width: 19px;\n\theight: 19px;\n\tfont-weight: 600;\n\tfont-size: 10px;\n\tcolor: var(--white-text);\n\tborder-radius: 50%;\n\tborder: 1px solid var(--badge-primary-color);\n\tbackground: var(--badge-primary-color);\n\t-webkit-border-radius: 50%;\n\t-moz-border-radius: 50%;\n\t-ms-border-radius: 50%;\n\t-o-border-radius: 50%;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\tline-height: normal;\n}\n\n.displayTable {\n\twidth: 100%;\n\tdisplay: table;\n}\n\n.displayTableRow {\n\twidth: 100%;\n\tdisplay: table-row;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.contentSection {\n\tposition: relative;\n\twidth: 90%;\n\tvertical-align: middle;\n\tbackground: var(--primary-white-bg);\n\tpadding: 0px 24px;\n}\n\n.displayTableCellIcon {\n\tdisplay: table-cell;\n\twidth: 10%;\n}\n\n.nameWidth {\n\twidth: 20%;\n}\n\n.addressWidth {\n\twidth: 65%;\n}\n\n.btnWidth {\n\twidth: 15%;\n}\n\n.vtrImg {\n\tvertical-align: middle;\n}\n\n.inboxHeadingText {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.inboxProfileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\twidth: 88px;\n\theight: 88px;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--common-link-color);\n\tbackground-color: transparent;\n\tpadding: 5px;\n\tposition: relative;\n\tz-index: 5;\n}\n\n.inboxProfileAvatarLink img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: contain;\n\tbackground-color: var(--primary-white-bg);\n\tborder-radius: 50%;\n}\n\n.inBoxContentSection {\n\tpadding-left: 29px;\n\tflex: 1;\n}\n\n.contentGridBox {\n\tdisplay: grid;\n\tgrid-template-columns: 28% 1fr auto;\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.iconSpace {\n\tmargin-right: 4px;\n\tposition: relative;\n\ttop: 2px;\n}\n\n.inlineBlock {\n\tdisplay: inline-block;\n}\n\n.inboxPaddingRight {\n\tpadding-right: 24px;\n}\n\n.displayFlexContainer {\n\tdisplay: flex;\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n\t.contentSection {\n\t\tpadding: 0px 12px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.displayBlock {\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\tmargin-bottom: 6px;\n\t}\n\n\t.contentSection {\n\t\twidth: 64% !important;\n\t}\n\n\t.vtrImg {\n\t\tvertical-align: top;\n\t}\n\n\t.contentSection {\n\t\tpadding: 0px 24px;\n\t}\n\n\t.inboxProfileAvatarLink {\n\t\twidth: 70px;\n\t\theight: 70px;\n\t}\n\n\t.count {\n\t\ttop: -8px;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.nameWidth {\n\t\twidth: 30%;\n\t}\n\n\t.addressWidth {\n\t\twidth: 52%;\n\t}\n\n\t.btnWidth {\n\t\twidth: 18%;\n\t}\n\n\t.contentSection {\n\t\twidth: 88%;\n\t}\n\n\t.displayTableCellIcon {\n\t\tdisplay: table-cell;\n\t\twidth: 12%;\n\t}\n}\n\n.paddingR20 {\n\tpadding-right: 20px;\n}\n\n@media (max-width: 640px) {\n\t.contentGridBox {\n\t\tgrid-template-columns: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"threadSubjectUnread": `Inbox-threadSubjectUnread-oEIG_`,
	"threadSubject": `Inbox-threadSubject-qWzgX`,
	"inboxPaddingRight": `Inbox-inboxPaddingRight-ZCp1q`,
	"textTruncate": `Inbox-textTruncate-Ir14_`,
	"threadName": `Inbox-threadName-Ebl8m`,
	"threadBody": `Inbox-threadBody-Uz9qm`,
	"textMuted": `Inbox-textMuted-XuZSE`,
	"threadLabel": `Inbox-threadLabel-U3lam`,
	"listUnstyled": `Inbox-listUnstyled-QWuIF`,
	"space1": `Inbox-space1-PM5y6`,
	"spaceTop1": `Inbox-spaceTop1-BsN8H`,
	"spaceTop2": `Inbox-spaceTop2-cJh0f`,
	"threadAction": `Inbox-threadAction-AbrU_`,
	"iconText": `Inbox-iconText-iZdU1`,
	"PanelBody": `Inbox-PanelBody-QtWfj`,
	"showLg": `Inbox-showLg-qf7a1`,
	"labelText": `Inbox-labelText-_FG6d`,
	"tabs": `Inbox-tabs-bhoU9`,
	"threadRead": `Inbox-threadRead-pXS_U`,
	"noTextLine": `Inbox-noTextLine-rm8jZ`,
	"progressContainerResponsive": `Inbox-progressContainerResponsive-HbOxz`,
	"h4": `Inbox-h4-Iwmm6`,
	"formControlSelect": `Inbox-formControlSelect-xg0iP`,
	"threadAuthor": `Inbox-threadAuthor-hkbch`,
	"threadAvatar": `Inbox-threadAvatar-e2NWg`,
	"threadDate": `Inbox-threadDate-SEzGS`,
	"threadLink": `Inbox-threadLink-Od4te`,
	"panelHeader": `Inbox-panelHeader-LqU4T`,
	"textRight": `Inbox-textRight-IjCb_`,
	"listLayout": `Inbox-listLayout-RD8rt`,
	"profileAvatarSection": `Inbox-profileAvatarSection-oZf8O`,
	"profileAvatarLink": `Inbox-profileAvatarLink-IMDqZ`,
	"iconColor": `Inbox-iconColor-aCcZu`,
	"xsHidden": `Inbox-xsHidden-X8APs`,
	"containerResponsive": `Inbox-containerResponsive-zXS9R`,
	"active": `Inbox-active-fLLqM`,
	"tabItem": `Inbox-tabItem-AxTbR`,
	"count": `Inbox-count-sAhbv`,
	"displayTable": `Inbox-displayTable-xBQWO`,
	"displayTableRow": `Inbox-displayTableRow-KGrZY`,
	"displayTableCell": `Inbox-displayTableCell-XQSB4`,
	"contentSection": `Inbox-contentSection-jBhew`,
	"displayTableCellIcon": `Inbox-displayTableCellIcon-AGofn`,
	"nameWidth": `Inbox-nameWidth-TQEOv`,
	"addressWidth": `Inbox-addressWidth-kgU3E`,
	"btnWidth": `Inbox-btnWidth-zqDaz`,
	"vtrImg": `Inbox-vtrImg-sENev`,
	"inboxHeadingText": `Inbox-inboxHeadingText-YcpDM`,
	"inboxProfileAvatarLink": `Inbox-inboxProfileAvatarLink-IV23S`,
	"inBoxContentSection": `Inbox-inBoxContentSection-qMA2u`,
	"contentGridBox": `Inbox-contentGridBox-Z8nRJ`,
	"displayFlex": `Inbox-displayFlex-a_VAN`,
	"iconSpace": `Inbox-iconSpace-_OCle`,
	"inlineBlock": `Inbox-inlineBlock-cZdYc`,
	"displayFlexContainer": `Inbox-displayFlexContainer-UpnG7`,
	"displayBlock": `Inbox-displayBlock-SReoZ`,
	"paddingR20": `Inbox-paddingR20-wbIvQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
